import React, { useEffect, useState } from "react";
import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";

// Views
import Login from "../views/login/Login";
import NotFound from "../views/not-found/NotFound";
import HomeInternet from "../views/home-internet/HomeInternet";
import CoverageArea from "../views/coverage-area/CoverageArea";
import HomeLte from "../views/home-lte/HomeLte";
import ProductDetail from "../views/product-detail/ProductDetail";
import Compte from "../views/compte/Compte";
import Profil from "../views/compte/profil/Profil";
import CompteDetail from "../views/compte/compte-detail/CompteDetail";
import History from "../views/compte/history/History";
import MotDePasse from "../views/compte/mot-de-passe/MotDePasse";
import ForfaitDetail from "../views/forfait-detail/ForfaitDetail";
import Forfaits from "../views/forfaits/Forfaits";
import { isAuthenticated } from "../utils/AuthGuard";
import PasswordAccess from "../views/password-access/PasswordAccess";
import { getAbonneInfo_allRight } from "../services/abonne/AbonneRequest";
import NotUser from "../views/not-user/NotUser";
import LoadingPage from "../views/loading-page/LoadingPage";
import ForfaitAccueil from "../views/recharge-accueil/Recharge";
import AcheterForfait from "../views/forfaits/acheter/AcheterForfait";
import OffrirForfait from "../views/forfaits/offrir/OffrirForfait";
import EmprunterForfait from "../views/forfaits/emprunter/EmprunterForfait";
import MtnPlay from "../views/forfaits/mtn-play/MtnPlay";
import ForgetPassword from "../views/forget-password/ForgetPassword";
import ResetPassword from "../views/reset-password/ResetPassword";

const AppRoutes = () => {
  const ProtectedRoute = () => {
    return isAuthenticated() ? <Outlet /> : <Navigate to="/login" />;
  };

  const AuthGuard = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [fetchingData, setFetchingData] = useState(true);

    useEffect(() => {
      getAbonneInfo_allRight()
        .then((res) => {
          setFetchingData(false)
          setUser(res.data.donnee);
          console.log("USER API", res.data.donnee);
        })
        .catch((err) => {
          console.log("api error", err.response);
          if (err.response.status === 403) {
            navigate('/not-allowed')
          }
        });
    }, []);

    return sessionStorage.getItem("token") && user && user.motdepasseisactif ? (
      <>
        {console.log("1")}
        {!fetchingData ? <Outlet /> : <LoadingPage />}
      </>
    ) : sessionStorage.getItem("token") && user && !user.motdepasseisactif ? (
      <>
        {console.log("2")}
        {user && !user.motdepasseisactif ? (
          <>
            {console.log("wtf", user)}
            {sessionStorage.removeItem("token")}
          </>
        ) : null}
        {!fetchingData ? <Outlet /> : <LoadingPage />}
      </>
    ) : !sessionStorage.getItem("token") && user && user.motdepasseisactif ? (
      <>
        {console.log("3")}
        <Navigate to="/password-access" />
      </>
    ) : !sessionStorage.getItem("token") && user && !user.motdepasseisactif ? (
      <>
        {console.log("4", fetchingData)}
        {!fetchingData ? <Outlet /> : <LoadingPage />}
      </>
    ) : (
      <>{!fetchingData ? <Outlet /> : <LoadingPage />}</>
    );
  };

  return (
    <Routes>

      <Route exact path="*" element={<NotFound />} />

      <Route exact path="/moninternet" element={<Forfaits />}>
        <Route exact path="/moninternet" element={<AcheterForfait />} />
      </Route>

      <Route exact path="/" element={<Forfaits />}>
        <Route exact path="/" element={<AcheterForfait />} />
      </Route>

      {/* <Route exact path="/home-internet" element={<HomeInternet />} />
      <Route exact path="/coverage-area" element={<CoverageArea />} />
      <Route exact path="/home-lte" element={<HomeLte />} />
      <Route exact path="/product-detail" element={<ProductDetail />} /> */}

      <Route exact path="/compte" element={<Compte />}>
        <Route exact path="/compte/profil" element={<Profil />} />
        <Route exact path="/compte/detail" element={<CompteDetail />} />
        <Route exact path="/compte/history" element={<History />} />
        <Route exact path="/compte/password" element={<MotDePasse />} />
      </Route>

      <Route exact path="/not-allowed" element={<NotUser />} />

      <Route exact path="/password-access" element={<PasswordAccess />} />

      {/* <Route exact path="/forfaits" element={<AuthGuard />}> */}
        {/* <Route exact path="/forfaits" element={<Forfaits />} /> */}
      {/* </Route> */}

      {/* <Route exact path="/accueil" element={<AuthGuard />}> */}
        <Route exact path="/accueil" element={<ForfaitAccueil />} />
      {/* </Route> */}

      {/* <Route exact path="/detail-forfait/:id" element={<AuthGuard />}> */}
        <Route exact path="/detail-forfait/:id" element={<ForfaitDetail />} />
      {/* </Route>   */}

      <Route exact path="/compte" element={<Compte />}>
        <Route exact path="/compte/profil" element={<Profil />} />
        <Route exact path="/compte/detail" element={<CompteDetail />} />
        <Route exact path="/compte/history" element={<History />} />
        <Route exact path="/compte/password" element={<MotDePasse />} />
      </Route>

      <Route exact path="/forfaits" element={<Forfaits />}>
        <Route exact path="/forfaits" element={<AcheterForfait />} />
        <Route exact path="/forfaits/acheter" element={<AcheterForfait />} />
        <Route exact path="/forfaits/offrir" element={<OffrirForfait />} />
        <Route exact path="/forfaits/emprunter" element={<EmprunterForfait />} />
        <Route exact path="/forfaits/mtn-play" element={<MtnPlay />} />
      </Route>

      <Route exact path="/forget-password" element={<ForgetPassword />} />

      <Route exact path="/reset-password" element={<ResetPassword />} />

      <Route exact path="/login" element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
